<div class="priorities-container">
	@for (priority of priorityList; track priority) {
		<mat-checkbox
			color="primary"
			class="au-checkbox"
			[checked]="isChecked(priority)"
			(click)="$event.stopPropagation()"
			(change)="toggleSelection($event, priority)"
		>
			<div class="priority-wrapper">
				<div class="priority-text">{{ priority.text | translate }}</div>
				<div class="priority-value">
					<au-priority-level class="d-flex" [level]="priority.level" />
				</div>
			</div>
		</mat-checkbox>
	}
</div>
